import { z } from "zod";

const clientEnvSchema = z.object({
  // Turnstile
  NEXT_PUBLIC_TURNSTILE_SITE_KEY: z.string().optional(),

  // Site
  NEXT_PUBLIC_SITE_URL: z.url().optional(),

  // Analytics (client)
  NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
  NEXT_PUBLIC_POSTHOG_HOST: z.string().optional(),
  // PostHog release/version used to tag events, exceptions and logs
  NEXT_PUBLIC_POSTHOG_RELEASE: z.string().optional(),

  // Error Tracking (client)
  NEXT_PUBLIC_ERROR_DSN: z.string().optional(),
  NEXT_PUBLIC_ERROR_REPLAY: z
    .string()
    .transform((val) => val === "true")
    .optional()
    .default(false),
  NEXT_PUBLIC_ERROR_LOGS: z
    .string()
    .transform((val) => val === "true")
    .optional()
    .default(false),
  NEXT_PUBLIC_BETTERSTACK_LOGS_TOKEN: z.string().optional(),
  NEXT_PUBLIC_UMAMI_WEBSITE_ID: z.string().optional(),
  NEXT_PUBLIC_UMAMI_HOST: z.url().optional(),
  NEXT_PUBLIC_PLAUSIBLE_DOMAIN: z.string().optional(),
  NEXT_PUBLIC_PLAUSIBLE_HOST: z.url().optional(),
});

const parsed = clientEnvSchema.safeParse({
  NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env["NEXT_PUBLIC_TURNSTILE_SITE_KEY"],
  NEXT_PUBLIC_SITE_URL: process.env["NEXT_PUBLIC_SITE_URL"],
  NEXT_PUBLIC_POSTHOG_KEY: process.env["NEXT_PUBLIC_POSTHOG_KEY"],
  NEXT_PUBLIC_POSTHOG_HOST: process.env["NEXT_PUBLIC_POSTHOG_HOST"],
  NEXT_PUBLIC_POSTHOG_RELEASE: process.env["NEXT_PUBLIC_POSTHOG_RELEASE"],
  NEXT_PUBLIC_ERROR_DSN: process.env["NEXT_PUBLIC_ERROR_DSN"],
  NEXT_PUBLIC_ERROR_REPLAY: process.env["NEXT_PUBLIC_ERROR_REPLAY"],
  NEXT_PUBLIC_ERROR_LOGS: process.env["NEXT_PUBLIC_ERROR_LOGS"],
  NEXT_PUBLIC_BETTERSTACK_LOGS_TOKEN: process.env["NEXT_PUBLIC_BETTERSTACK_LOGS_TOKEN"],
  NEXT_PUBLIC_UMAMI_WEBSITE_ID: process.env["NEXT_PUBLIC_UMAMI_WEBSITE_ID"],
  NEXT_PUBLIC_UMAMI_HOST: process.env["NEXT_PUBLIC_UMAMI_HOST"],
  NEXT_PUBLIC_PLAUSIBLE_DOMAIN: process.env["NEXT_PUBLIC_PLAUSIBLE_DOMAIN"],
  NEXT_PUBLIC_PLAUSIBLE_HOST: process.env["NEXT_PUBLIC_PLAUSIBLE_HOST"],
});

if (!parsed.success) {
  console.error("Invalid client environment variables:", z.treeifyError(parsed.error));
}

const enableTurnstileRaw = process.env["NEXT_PUBLIC_ENABLE_TURNSTILE"];
const enableTurnstile = enableTurnstileRaw === "true" ? true : enableTurnstileRaw === "false" ? false : undefined;

export const isTurnstileEnabled =
  !!parsed.data?.NEXT_PUBLIC_TURNSTILE_SITE_KEY && enableTurnstile !== false;

export const envClient = parsed.success
  ? parsed.data
  : {
      NEXT_PUBLIC_TURNSTILE_SITE_KEY: undefined,
      NEXT_PUBLIC_SITE_URL: undefined,
      NEXT_PUBLIC_POSTHOG_KEY: undefined,
      NEXT_PUBLIC_POSTHOG_HOST: undefined,
      NEXT_PUBLIC_POSTHOG_RELEASE: undefined,
      NEXT_PUBLIC_ERROR_DSN: undefined,
      NEXT_PUBLIC_ERROR_REPLAY: false,
      NEXT_PUBLIC_ERROR_LOGS: false,
      NEXT_PUBLIC_BETTERSTACK_LOGS_TOKEN: undefined,
      NEXT_PUBLIC_UMAMI_WEBSITE_ID: undefined,
      NEXT_PUBLIC_UMAMI_HOST: undefined,
      NEXT_PUBLIC_PLAUSIBLE_DOMAIN: undefined,
      NEXT_PUBLIC_PLAUSIBLE_HOST: undefined,
    };
